'use strict';

const statsBuffer = {
    value: null,
    addProjectionMetrics: null,
};

exports.statsBuffer = statsBuffer;
//# sourceMappingURL=buffer.cjs.map
